import React from 'react'
import styles from './Congrats.sass'

export const Congrats = () => {
  return <div className={styles.congrats}>Congrats 🎉</div>
}
